module.exports = __webpack_public_path__ + "static/media/step3-2.04a55118.png";